module.exports = __webpack_public_path__ + "img/Fortinet.251d6bc.svg";